import { internalFetch, postCsv } from '../utils/fetchHelper';
import type { IImportCsvRow } from '../utils/csvHelpers';
import { IPagedCollection } from '@moko/utils';

export interface IGroupInUser {
  id: number;
  name: string;
}

export interface IGroupMember {
  id: number;
  userName: string;
}

export interface IGroup {
  id: number;
  name: string;
  contractorId?: number;
  users: IGroupMember[];
}

export interface ICreateGroupRequest {
  name: string;
  contractorId?: number;
}

export interface ICreateGroupResponse {
  groupId: number;
}

export interface IUpdateGroupRequest {
  name: string;
  contractorId?: number;
}

export const getGroups = async (
  abortController: AbortController,
  pageSize: number,
  pageNo: number,
  orderBy?: string,
  search?: string
): Promise<IPagedCollection<IGroup>> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/a/groups?pageSize=${pageSize}&pageNo=${pageNo}${
      orderBy ? `&orderBy=${orderBy}` : ''
    }${search ? `&search=${search}` : ''}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController
  );
};

export const getGroup = async (
  abortController: AbortController,
  groupId: number
): Promise<IGroup> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/a/group?groupId=${groupId}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController
  );
};

export const editGroup = async (
  abortController: AbortController,
  groupId: number,
  group: IUpdateGroupRequest
): Promise<number> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/a/group?groupId=${groupId}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'PUT',
    abortController,
    JSON.stringify(group)
  );
};

export const deleteGroup = async (
  abortController: AbortController,
  groupId: number
): Promise<number> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/a/group?groupId=${groupId}`,
    'DELETE',
    abortController
  );
};

export const createGroup = async (
  abortController: AbortController,
  tenant: ICreateGroupRequest
): Promise<ICreateGroupResponse> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/a/group`,
    'POST',
    abortController,
    JSON.stringify(tenant)
  );
};

export interface IImportGroupsResponse {
  importGroupsResponses: IImportCsvRow[];
  messages: string[];
  errorsCount: number;
}

export const importGroups = (
  abortController: AbortController,
  csvContent: string
): Promise<IImportGroupsResponse> =>
  postCsv<IImportGroupsResponse>(
    `${import.meta.env.VITE_BACKEND_API_URL}/a/importGroups`,
    csvContent,
    abortController
  );

export const exportGroups = async (
  abortController: AbortController
): Promise<string> => {
  const response: Response = await internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/a/exportGroups?code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController,
    undefined,
    true
  );

  return response.text();
};
